import {
  IBrandTileConfigurationProp,
  withConfigurationConsumer,
} from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/configurableBrandTileUtils";
import { ShowroomTileBadge } from "@faire/deprecated-retailer-visitor-shared/components/Showroom/ShowroomTileBadge";
import { TopShopTileBadge } from "@faire/deprecated-retailer-visitor-shared/components/TopShop/TopShopTileBadge";
import { useTopShopVisibility } from "@faire/deprecated-retailer-visitor-shared/components/TopShop/useTopShopVisibility";
import { ILeanBrandTile } from "@faire/web-api--source/indigofair/data/ILeanBrandTile";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";

interface IProps extends IBrandTileConfigurationProp {
  tile: ILeanBrandTile;
}

const BrandTileBadgeBase: React.FC<IProps> = (props) => {
  const { brand } = props.tile;

  const { isTopShopContentVisibleForBrand } = useTopShopVisibility(
    brand?.is_top_shop
  );

  const renderNonEventBadge = () => {
    if (brand?.is_showroom) {
      if (props.configuration.disableShowroom) {
        return null;
      }

      return (
        <StyledShowroomTileBadge
          token={brand?.token}
          customEventName="brand-tile"
        />
      );
    }

    if (isTopShopContentVisibleForBrand) {
      if (props.configuration.disableTopShop) {
        return null;
      }
      return <StyledTopShopTileBadge />;
    }

    return null;
  };

  return <Wrapper>{renderNonEventBadge()}</Wrapper>;
};

export const BrandTileBadge = withConfigurationConsumer(BrandTileBadgeBase);

const Wrapper = styled(Row)`
  position: absolute;
  top: ${getSpacing("1x")};
  left: ${getSpacing("1x")};
  z-index: 3;
`;

const StyledTopShopTileBadge = styled(TopShopTileBadge)`
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  position: relative;
`;

const StyledShowroomTileBadge = styled(ShowroomTileBadge)`
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  position: relative;
`;
